// extracted by mini-css-extract-plugin
export default {"labelAndInput":"styles_labelAndInput__u2yr8","inline":"styles_inline__jjUsb","label":"styles_label__rBXw-","input":"styles_input__wDJNI","checkbox":"styles_checkbox__dhFkk"};